import { useState } from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  content: string | null;
  contentFetchStatus: string | null;
};

export function ExpandableArticle({ content, contentFetchStatus }: Props) {
  const [open, setOpen] = useState(false);

  if (!content) {
    if (contentFetchStatus && contentFetchStatus !== 'ok') {
      return (
        <div className="text-muted text-[0.7rem] mt-1 font-(family-name:--font-ui)">
          article: {contentFetchStatus}
        </div>
      );
    }
    return null;
  }

  const kb = Math.round(content.length / 1000);
  return (
    <div className="mt-2">
      <Button
        variant="default"
        size="sm"
        onClick={() => setOpen((v) => !v)}
        className="text-[0.7rem]"
      >
        {open ? '− Hide article' : `+ Show article (${kb}K)`}
      </Button>
      {open && (
        <div className="mt-2 p-3 bg-surface-elevated border-l-2 border-accent text-sm whitespace-pre-wrap max-h-[400px] overflow-auto">
          {content}
        </div>
      )}
    </div>
  );
}
